export class RegistrationStatus {
  isRegistrationCompleted: boolean;
  isLastNameRequired: boolean;
  isFirstNameRequired: boolean;
  isTokenValid: boolean;

  constructor(dto?: any) {
    this.isRegistrationCompleted = dto?.isRegistrationCompleted || false;
    this.isLastNameRequired = dto?.isLastNameRequired || false;
    this.isFirstNameRequired = dto?.isFirstNameRequired || false;
    this.isTokenValid = dto?.isTokenValid || false;
  }
}
